module.exports = __webpack_public_path__ + "img/icon-similar-blue.4f77bf05.svg";